import { get } from "lodash";
import React from "react";
import { BooleanField, DateField, List as RaList, SelectField, TextField } from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import Expand from "./Expand";
import CsvField from "./fields/CsvField";
import StatusField from "./fields/StatusField";
import Filters from "./Filters";
import LogsButton from "./LogsButton";
import types from "./types";

const Datagrid = (props) => {
	const hasBookmakerFilter = !!get(props, "filterValues.bookmaker_id");
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField source="bookmaker.name" variant="subtitle" gutterBottom component="p" style={{ fontWeight: "bold" }} />
					<StatusField source="status" />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<SelectField source="type" choices={types} variant="overline" />
					<DateField source="date" color="textSecondary" />
					<DateField source="created" showTime color="textSecondary" />
					<BooleanField source="is_manually" />
					<CsvField source="csv.path" title="csv.name" variant="body1" color="textPrimary" />
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					<LogsButton />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasBookmakerFilter && <TextField style={{ fontWeight: "bold" }} source="bookmaker.name" label="resources.bookmaker-imports.fields.bookmaker_id" />}
			<SelectField source="type" variant="overline" choices={types} />
			<CsvField source="csv.path" title="csv.name" />
			<StatusField source="status" />
			<DateField source="date" />
			<DateField source="created" showTime />
			<BooleanField source="is_manually" />
			<LogsButton />
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList {...props} classes={classes} filters={<Filters />} perPage={perPage()} exporter={false} sort={{ field: "created", order: "DESC" }} actions={<Actions />}>
			<Datagrid {...props} expand={<Expand />} />
		</RaList>
	);
};
export default List;
